import { render, staticRenderFns } from "./summaryBusinessSkillsScores.vue?vue&type=template&id=184aefac&scoped=true"
import script from "./summaryBusinessSkillsScores.vue?vue&type=script&lang=js"
export * from "./summaryBusinessSkillsScores.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "184aefac",
  null
  
)

export default component.exports